document.addEventListener("DOMContentLoaded", () => {
    const accordionBlocks = document.querySelectorAll(".blk-accordion");

    accordionBlocks.forEach(block => {
        const accordions = block.querySelectorAll(".accordion");

        accordions.forEach(acc => {
            const title = acc.querySelector(".accordion_title");

            if (title) {
                title.addEventListener("click", () => {
                    acc.classList.toggle("active");
                    accordions.forEach(other => {
                        if (other !== acc) other.classList.remove("active");
                    });
                });
            }
        });
    });
});
